class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
    
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.defaultProductsHTML = this.predictiveSearchResults.innerHTML;
    
        this.input.addEventListener('input', this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this));
        
      }

      connectedCallback() {
        this.openSearchPop();
        this.closeSearchPop();
        this.backgroundClose();
      }
    
      onChange() {
        const searchTerm = this.input.value.trim();
    
        if (!searchTerm.length) {
            this.showDefaultProducts();
        } else {
            this.getSearchResults(searchTerm);
        }
    
        this.onReset(searchTerm);
      }

      showDefaultProducts() {
        let resultCon = this.querySelector('.WI_searchCon_result');
        let resultIn = this.querySelector('.WI_searchCon_resultIn');
        
        console.log('showDefaultProducts called', resultCon);
        
        if (this.defaultProductsHTML) {
            this.predictiveSearchResults.innerHTML = this.defaultProductsHTML;
        }
        
        if (resultCon) {
            resultCon.style.display = 'flex';
            resultCon.classList.add('WI_searchCon_resultActive');
            setTimeout(() => {
                resultCon.style.opacity = "1";
                if (resultIn) resultIn.style.opacity = "1";
            }, 10);
        }
      }

      onReset(searchTerm) {
        let clearBtn = this.querySelector('.WI_searchCon_clean');
        console.log(searchTerm);
        if(searchTerm.length > 0) {
            clearBtn.style.visibility = 'visible';
            clearBtn.addEventListener('click', (e) => {
              e.preventDefault();
              this.input.value = '';
              this.showDefaultProducts();
              this.onReset('');
          });
        } else {
            clearBtn.style.visibility = 'hidden';
        }
      }
    
      getSearchResults(searchTerm) {
        let resultCon = this.querySelector('.WI_searchCon_result');
            console.log(resultCon);
            resultCon.style.display = 'flex';
            resultCon.classList.add('WI_searchCon_resultActive');
            setTimeout(() => {
                resultCon.style.opacity = "1";
            }, 10);
        const localeRoot = window.Shopify?.routes?.root || '/';
        fetch(`${localeRoot}search/suggest?q=${searchTerm}&section_id=predictive-search`)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
            }
    
            return response.text();
          })
          .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            this.querySelector('.WI_searchCon_resultIn').style.opacity = "1";
            // document.dispatchEvent(new CustomEvent('wishRefresh', { bubbles: true }));
          })
          .catch((error) => {
            console.error(error);
          });
      }
    
      open() {
       
      }
    
      serachEmpty() {
        let resultCon = this.querySelector('.WI_searchCon_result');
        let clearBtn = this.querySelector('.WI_searchCon_clean');
        resultCon.style.opacity = "0";
        this.querySelector('.WI_searchCon_resultIn').style.opacity = "0";
        clearBtn.style.visibility = 'hidden';
        setTimeout(() => {
            resultCon.style.display = 'none';
            resultCon.classList.remove('WI_searchCon_resultActive');
            
        }, 310);
      }
    
      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }

      openSearchPop() {
        document.addEventListener('click', (e) => {
          const trigger = e.target.closest('.WI_searchOpen');
          if (!trigger) return;
          e.preventDefault();
          this.style.display = 'block';
          setTimeout(() => {
              this.classList.add('wi-search_active');
              this.querySelector('.WI_searchIn').style.top = '0';
              this.querySelector('.WI_searchIn').style.opacity = '1';
              this.showDefaultProducts();
              requestAnimationFrame(() => {
                this.querySelector("#Search").focus();
              });
          }, 10);
        });
      }

      closeSearchPop() {
        let searchOPener = document.querySelector('.WI_searchCon_close button');
        searchOPener.addEventListener('click', (e) => {
            e.preventDefault();
            this.resetSearch();
        });
      }

      resetSearch() {
        this.input.value = '';
        
        this.showDefaultProducts();
        
        let clearBtn = this.querySelector('.WI_searchCon_clean');
        if (clearBtn) clearBtn.style.visibility = 'hidden';
        
        this.classList.remove('wi-search_active');
        this.querySelector('.WI_searchIn').style.top = '-100%';
        this.querySelector('.WI_searchIn').style.opacity = '0';
        
        setTimeout(() => {
            this.style.display = 'none';
        }, 310);
      }

      backgroundClose(){
        const wiSearch = document.querySelector('wi-search');

        wiSearch.addEventListener('click', (e) => {
          const path = e.composedPath();
        
          if (path[0] === wiSearch && path[1] !== wiSearch.shadowRoot?.activeElement) {
            this.resetSearch();
          }
        });
      }
}

customElements.define('wi-search', PredictiveSearch);